module.exports = __webpack_public_path__ + "static/media/Products.96017f4b.csv";